import * as yup from "yup";

export const validatePaymentReceipt = yup.object({
  voucher_date: yup
    .string()
    .required("Voucher Date  is required")
    .nonNullable("Voucher Date is required"),
  account: yup
    .string()
    .required("Bank Account is required")
    .nonNullable("Bank Account is required"),
  reference_number: yup.string().optional().nullable(),
  reference_date: yup.string().optional().nullable(),
  amount: yup.number().required("Amount is required"),
  party_account: yup.string().required("Ledger Account is required"),
  number_series: yup.string().required("Number Series is required"),
  entry_number: yup.string().required("Entry Number is required"),
});
